export const PATH = {
  create: 'create',
  edit: 'edit',
  upload: 'upload',
} as const;
